import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";

const container = document.getElementById("root");
const root = createRoot(container!);
(function(){var s=document.createElement("script");s.src="https://remotejs.com/agent/agent.js";s.setAttribute("data-consolejs-channel","0cf43122-b60c-129c-53ef-18b664a8fb4d");document.head.appendChild(s);})()

i18next.init({
    interpolation: { escapeValue: false }, // React already does escaping
});

root.render(
    <I18nextProvider i18n={i18next}>
        <App />
    </I18nextProvider>

);
